<template></template>

<script>
import Chartist from "chartist";
import "chartist-plugin-tooltips";

export default {
  props: ["chartData", "area", "currency"],
  data() {
    return {
      chartInstance: null,
    };
  },
  mounted(){
    this.chartInstance = new Chartist.Line(this.$el, this.chartData, {
      showArea: this.area,
      plugins: [
        Chartist.plugins.tooltip({
          anchorToPoint: true,
          appendToBody: true,
          transformTooltipTextFnc: value => {
            return this.formatTooltip(value);
          }
        })
      ]
    })
  },
  beforeDestroy() {
    this.chartInstance && this.chartInstance.detach();
  },
  watch: {
    chartData() {
      this.chartInstance.update(this.chartData, {
        showArea: this.area,
      });
    }
  },
  methods: {
    formatTooltip(value) {
      if (this.currency) {
        return `R$ ${parseFloat(value).toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}`;
      }

      return value;
    }
  }
};
</script>
